import SubmitModalButton from 'components/Custom/SubmitModalButton'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  Card,
  CardBody,
  Col,
  FormGroup,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from 'reactstrap'
import { getJobApplications } from 'store/Recruitment/actions'
import Select from 'views/pages/Select'
import ApplicationCard from './ApplicationCard'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faBook,
  faBoxArchive,
  faCircleExclamation,
  faCircleXmark,
  faLockOpen,
  faRotate,
  faStar,
  faTrash,
} from '@fortawesome/free-solid-svg-icons'
import AxiosInstance from 'utils/AxiosInstance'
import { archiveMultipleApplications } from 'store/Recruitment/actions'
import { setAllJobApplicationsAndJobs } from 'store/Recruitment/actions'
import { setAreYouSureModalData } from 'store/Recruitment/actions'
import { deleteMultipleApplications } from 'store/Recruitment/actions'
import { updateMultipleApplicationsStage } from 'store/Recruitment/actions'
import CreateInterviewCard from './CreateInterviewCard'
import { setFormSubmitted } from 'store/Recruitment/actions'
import { createMultipleInterviews } from 'store/Recruitment/actions'
import CreateJobOnboardCard from './CreateJobOnboardCard'
import { createMultipleOnBoard } from 'store/Recruitment/actions'
import { reviewWithAi } from 'store/Recruitment/actions'
import { getJobApplicationsWithReviews } from 'store/Recruitment/actions'

function AiFilteringModal({ showModal, setShowModal, jobs }) {
  const [selectedJob, setSelectedJob] = useState(null)
  const [selectedApplications, setSelectedApplications] = useState([])

  const dispatch = useDispatch()
  const { jobApplications, reviewingApplications } = useSelector(
    (store) => store.recruitment
  )

  const [jobStages, setJobStages] = useState([])
  const [showChangeStageModal, setShowChangeStageModal] = useState(false)

  const [selectedStage, setSelectedStage] = useState(null)

  const [interviewData, setInterviewData] = useState({})
  const [onboardData, setOnboardData] = useState({})

  const [showRestoreButton, setShowRestoreButton] = useState(false)
  const [showArchiveButton, setShowArchiveButton] = useState(false)

  const [showReviewmingModal, setShowReviewingModal] = useState(false)

  useEffect(() => {
    if (reviewingApplications) {
      setShowReviewingModal(true)
    }
    if (!reviewingApplications) {
      setShowReviewingModal(false)
    }
  }, [reviewingApplications])

  useEffect(() => {
    AxiosInstance.get(`/recruitment/setup/job_stage`).then((data) =>
      setJobStages(
        data?.map((el) => {
          return {
            name: el?.value,
            id: el?.id,
            interview_stage: el?.interview_stage,
            hired_stage: el?.hired_stage,
          }
        })
      )
    )
  }, [])

  useEffect(() => {
    if (!showChangeStageModal) {
      setSelectedStage(null)
    }
  }, [showChangeStageModal])

  useEffect(() => {
    if (!selectedApplications.length) {
      setShowChangeStageModal(false)
    }
  }, [selectedApplications.length])

  const interviewStage =
    jobStages &&
    jobStages.length &&
    jobStages.find((stage) => stage.interview_stage === 'true')

  const hiredStage =
    jobStages &&
    jobStages.length &&
    jobStages.find((stage) => stage.hired_stage === 'true')

  const interviewStageSelected =
    interviewStage && interviewStage.id === selectedStage

  const hiredStageSelected = hiredStage && hiredStage.id === selectedStage

  const isInterviewDataValid = () => {
    if (!interviewStageSelected) return true

    return selectedApplications.every((appId) => {
      const data = interviewData[appId]
      return (
        data &&
        data.selectedAdmins &&
        data.interviewDate &&
        data.interviewTime &&
        data.endInterviewTime
      )
    })
  }

  const isOnboardDataValid = () => {
    if (!hiredStageSelected) return true

    return selectedApplications.every((appId) => {
      const data = onboardData[appId]
      return data && data.joiningDate && data.salaryType && data.status
    })
  }

  useEffect(() => {
    dispatch(setFormSubmitted(false))
  }, [dispatch])

  const jobPositions = selectedJob?.option?.positions || 0

  const sortedApplications = [...jobApplications]
    .filter((app) => app?.score != null)
    .sort((a, b) => b.score - a.score)

  const topApplications = new Set()
  let positionsLeft = jobPositions
  let i = 0

  while (positionsLeft > 0 && i < sortedApplications.length) {
    const currentScore = sortedApplications[i].score
    const sameScoreGroup = sortedApplications.filter(
      (app) => app.score === currentScore
    )

    if (sameScoreGroup.length <= positionsLeft) {
      sameScoreGroup.forEach((app) => topApplications.add(app.id))
      positionsLeft -= sameScoreGroup.length
      i += sameScoreGroup.length
    } else {
      break
    }
  }

  return (
    <>
      <Modal
        style={{ width: '90%', minWidth: '90%' }}
        isOpen={showModal}
        toggle={() => {
          setShowModal(false)
          dispatch(setAllJobApplicationsAndJobs())
        }}
        centered
        scrollable
      >
        <ModalHeader
          className='border-bottom'
          toggle={() => {
            setShowModal(false)
            dispatch(setAllJobApplicationsAndJobs())
          }}
        >
          Review Job Applications with AI
        </ModalHeader>
        <ModalBody className='scrollbar'>
          {!selectedJob && (
            <h1 className='mx-auto text-center'>Please Select a Job first!</h1>
          )}
          <FormGroup className='create-job-input w-50 mx-auto'>
            <label className='form-control-label' htmlFor={`field`}>
              Job
            </label>
            <Select
              options={jobs}
              valueKey={'id'}
              multi={false}
              onChange={(e) => {
                setSelectedJob(e)
                if (e) {
                  if (e.option.id !== selectedJob?.option?.id) {
                    setSelectedApplications([])
                  }
                  dispatch(getJobApplicationsWithReviews(e.option.id))
                }
              }}
              selectedOptions={selectedJob}
            />
          </FormGroup>

          {selectedJob && jobApplications && jobApplications.length ? (
            <>
              <div className='d-flex mt-3 mb-5'>
                <button
                  onClick={() => setShowChangeStageModal(!showChangeStageModal)}
                  disabled={!selectedApplications.length}
                  className='btn btn-info mr-2'
                >
                  Change Stage{' '}
                  <FontAwesomeIcon icon={faRotate} className='ml-1' />
                </button>

                <button
                  onClick={() =>
                    dispatch(archiveMultipleApplications(selectedApplications))
                  }
                  disabled={!selectedApplications.length}
                  className='btn btn-danger mr-2'
                  onMouseEnter={() => setShowArchiveButton(true)}
                  onMouseLeave={() => setShowArchiveButton(false)}
                >
                  {showArchiveButton && <span>Archive Selected</span>}
                  <FontAwesomeIcon icon={faBoxArchive} />
                </button>
                <button
                  onClick={() =>
                    dispatch(
                      archiveMultipleApplications(selectedApplications, 0)
                    )
                  }
                  disabled={!selectedApplications.length}
                  className='btn btn-secondary mr-2'
                  onMouseEnter={() => setShowRestoreButton(true)}
                  onMouseLeave={() => setShowRestoreButton(false)}
                >
                  {showRestoreButton && <span>Restore Selected</span>}
                  <FontAwesomeIcon icon={faLockOpen} />
                </button>
                <button
                  onClick={() =>
                    dispatch(
                      setAreYouSureModalData({
                        show: true,
                        customFn: () =>
                          dispatch(
                            deleteMultipleApplications(selectedApplications)
                          ),
                      })
                    )
                  }
                  disabled={!selectedApplications.length}
                  className='btn btn-danger mr-2 ml-auto'
                >
                  Delete Permanently{' '}
                  <FontAwesomeIcon icon={faTrash} className='ml-1' />
                </button>
              </div>
              <Row className='ml-0 mt--4 mb-3'>
                <Col className='pl-1 mt-3'>
                  <span>
                    <span className='legend-rectangle chosen-legend'></span>
                    <span className='legend-text'>Chosen</span>
                  </span>
                  <span className='ml-3'>
                    <span className='legend-rectangle undecided-legend'></span>
                    <span className='legend-text'>
                      Undecided (equal scores)
                    </span>
                  </span>
                  <span className='ml-3'>
                    <span className='legend-rectangle nocv-legend'></span>
                    <span className='legend-text'>Couldn't read CV</span>
                  </span>
                </Col>
              </Row>
              {showChangeStageModal ? (
                <Card>
                  <CardBody>
                    <div className='d-flex align-items-center justify-content-between'>
                      <div
                        className='d-flex align-items-center'
                        style={{ gap: '1.5rem' }}
                      >
                        {jobStages?.map((stage) => (
                          <button
                            onClick={() => setSelectedStage(stage?.id)}
                            className={`btn ${
                              selectedStage !== stage?.id
                                ? 'btn-outline-info'
                                : 'btn-info'
                            }`}
                            key={stage?.id}
                          >
                            {stage?.name}
                          </button>
                        ))}
                      </div>
                      <div>
                        <button
                          onClick={() => {
                            if (interviewStageSelected) {
                              dispatch(
                                createMultipleInterviews(interviewData, () => {
                                  dispatch(
                                    updateMultipleApplicationsStage(
                                      selectedApplications,
                                      selectedStage
                                    )
                                  )
                                  setShowChangeStageModal(false)
                                })
                              )
                              return
                            }

                            if (hiredStageSelected) {
                              dispatch(
                                createMultipleOnBoard(onboardData, () => {
                                  dispatch(
                                    updateMultipleApplicationsStage(
                                      selectedApplications,
                                      selectedStage
                                    )
                                  )
                                  setShowChangeStageModal(false)
                                })
                              )
                              return
                            }

                            dispatch(
                              updateMultipleApplicationsStage(
                                selectedApplications,
                                selectedStage
                              )
                            )
                          }}
                          disabled={
                            !selectedStage ||
                            (interviewStage && !isInterviewDataValid()) ||
                            (hiredStage && !isOnboardDataValid())
                          }
                          className='btn btn-success mr-2'
                        >
                          Update Stage
                        </button>
                        <button
                          title='Close'
                          className='btn p-2 btn-danger'
                          onClick={() => setShowChangeStageModal(false)}
                        >
                          <FontAwesomeIcon
                            icon={faCircleXmark}
                            size='xl'
                            className=''
                          />
                        </button>
                      </div>
                    </div>
                    {interviewStageSelected || hiredStageSelected ? (
                      <h2 className='text-danger text-center mt-3'>
                        Please fill all the required fields of all the selected
                        applications to continue.
                      </h2>
                    ) : null}
                    {interviewStageSelected &&
                      selectedApplications.length > 0 &&
                      selectedApplications.map((applicationId) => {
                        const application = jobApplications.find(
                          (job) => job.id === applicationId
                        )

                        return (
                          <CreateInterviewCard
                            key={applicationId}
                            application={application}
                            data={interviewData[applicationId] || {}}
                            onChange={(field, value) =>
                              setInterviewData((prev) => ({
                                ...prev,
                                [applicationId]: {
                                  ...prev[applicationId],
                                  [field]: value,
                                },
                              }))
                            }
                          />
                        )
                      })}

                    {hiredStageSelected &&
                      selectedApplications.length > 0 &&
                      selectedApplications.map((applicationId) => {
                        const application = jobApplications.find(
                          (job) => job.id === applicationId
                        )

                        if (application?.job_stage === hiredStage?.id) return
                        return (
                          <CreateJobOnboardCard
                            key={applicationId}
                            application={application}
                            data={onboardData[applicationId] || {}}
                            onChange={(field, value) =>
                              setOnboardData((prev) => ({
                                ...prev,
                                [applicationId]: {
                                  ...prev[applicationId],
                                  [field]: value,
                                },
                              }))
                            }
                          />
                        )
                      })}
                  </CardBody>
                </Card>
              ) : null}
              <div
                className='d-flex flex-row flex-wrap'
                style={{ gap: '1rem' }}
              >
                {jobApplications.map((application, i) => {
                  const score = application?.score
                  let borderColor = null

                  if (score != null) {
                    if (topApplications.has(application.id)) {
                      borderColor = 'green'
                    } else {
                      const sameScoreCount = jobApplications.filter(
                        (app) => app?.score === score
                      ).length
                      const higherScoreCount = jobApplications.filter(
                        (app) => app?.score != null && app?.score > score
                      ).length

                      if (
                        higherScoreCount < jobPositions &&
                        higherScoreCount + sameScoreCount > jobPositions
                      ) {
                        borderColor = 'orange'
                      }
                    }
                  }

                  return (
                    <ApplicationCard
                      index={i + 1}
                      jobPositions={jobPositions}
                      application={application}
                      key={application.id}
                      selectedApplications={selectedApplications}
                      setSelectedApplications={setSelectedApplications}
                      stage={jobStages?.find(
                        (el) => el?.id === application?.job_stage
                      )}
                      borderColor={borderColor}
                    />
                  )
                })}
              </div>
            </>
          ) : null}
        </ModalBody>
        <ModalFooter>
          {selectedJob && jobApplications.length && (
            <SubmitModalButton
              text={!reviewingApplications ? 'Review with AI' : 'Reviewing...'}
              icon={<FontAwesomeIcon icon={faStar} />}
              customFn={() => dispatch(reviewWithAi(selectedJob.option.id))}
            ></SubmitModalButton>
          )}
        </ModalFooter>
        <Modal
          className='modal-dialog-centered'
          isOpen={showReviewmingModal}
          toggle={() => setShowReviewingModal(false)}
        >
          <div className='modal-header'>
            <button
              aria-label='Close'
              className='close'
              data-dismiss='modal'
              type='button'
              onClick={() => setShowReviewingModal(false)}
            >
              <span aria-hidden={true}>×</span>
            </button>
          </div>
          <div className='modal-body text-center'>
            <FontAwesomeIcon
              icon={faCircleExclamation}
              size='4x'
              className='text-warning mt--4 mb-3'
            />
            <p>Reviewing Applications...</p>
            <p>This may take a while. Do not exit. Please wait!</p>
          </div>
        </Modal>
      </Modal>
    </>
  )
}

export default AiFilteringModal
